import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("psm_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem("psm_admin_token") && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem("psm_admin_token");
      window.dispatchEvent(new Event("psm-unauthorized"));
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;

// Stable visitor thread id for chat
export function getThreadId() {
  let id = localStorage.getItem("cam_thread_id");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2)) ;
    localStorage.setItem("cam_thread_id", id);
  }
  return id;
}

export function getVisitorName() {
  return localStorage.getItem("cam_visitor_name") || "";
}

export function setVisitorName(name) {
  localStorage.setItem("cam_visitor_name", name);
}

export function formatPrice(n) {
  if (typeof n !== "number") return "$" + n;
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

export function formatMileage(n) {
  if (typeof n !== "number") return n;
  return n.toLocaleString("en-US") + " mi";
}
